import { render, staticRenderFns } from "./ProfileDetails.vue?vue&type=template&id=b14e90a0&scoped=true&"
import script from "./ProfileDetails.vue?vue&type=script&lang=js&"
export * from "./ProfileDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDetails.vue?vue&type=style&index=0&id=b14e90a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14e90a0",
  null
  
)

export default component.exports